import type {LoaderFunctionArgs} from 'react-router'
import {redirectDocument, useLoaderData} from 'react-router-dom'

import {getNavigationState} from '../../../helpers/navigationStateCache.ts'
import {withRouter} from '../../../hocs/withRouter'
import {withThirdPartiesParam} from '../../../hocs/withThirdPartiesParam.js'
import {getInitialProps} from './getInitialProps'
import TechnicalDetailsSearchComponentRaw from './index.js'

// Import styles
import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const TechnicalDetailsSearchComponent = withThirdPartiesParam(TechnicalDetailsSearchComponentRaw)

export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname
  const query = Object.fromEntries(url.searchParams.entries())

  // Build routeInfo compatible with getInitialProps
  const routeInfo = {
    location: {
      pathname,
      query,
      search: url.search,
      state: getNavigationState(pathname)
    },
    params: {}
  }

  // Call existing getInitialProps
  const data = await getInitialProps({routeInfo, context})

  const redirectTo: unknown = data?.__HTTP__?.redirectTo
  // `redirectTo` points back at this very page when the search request fails, so a client-side
  // `redirect()` re-runs this loader in the browser, fails the same way and loops forever. Legacy
  // did `window.location = redirectTo` here (the old `withInitialProps` HOC), which retried
  // on the server, where the search succeeds. `redirectDocument` restores that, and the
  // same-target guard makes the loop impossible even if the server request fails too.
  if (typeof redirectTo === 'string' && redirectTo !== '' && redirectTo !== `${pathname}${url.search}`) {
    return redirectDocument(redirectTo)
  }

  return data
}

const TechnicalDetailsSearchWithRouter = withRouter(TechnicalDetailsSearchComponent)

export function Component() {
  const data = useLoaderData()
  return <TechnicalDetailsSearchWithRouter {...data} />
}
